import { cva } from 'class-variance-authority';

export const textIndicatorVariants = cva('bg-transparent px-2', {
  variants: {
    color: {
      error: ['text-error'],
      success: ['text-success'],
    },
    size: {
      medium: ['py-2'],
      small: ['py-1'],
    },
  },
  defaultVariants: {
    color: 'success',
    size: 'medium',
  },
});
